import SEO from '../components/SEO.jsx';
import { WA_URL } from '../config.js';

const SECTIONS = [
  {
    title: 'הגדרות',
    body: `"FocusMode" — יואב רון, עוסק מורשה, גבעת השלושה.\n"לקוח" — כל גוף שפנה ל-FocusMode לצורך קבלת שירות.\n"שירות" — כל עבודה שהוסכם עליה בין הצדדים בכתב (WhatsApp, מייל, הצעת מחיר חתומה).`
  },
  {
    title: 'היקף השירותים',
    body: `FocusMode מספקת שירותים בתחומים הבאים: ניהול פרויקטים טכנולוגיים, בניית אתרים ומערכות עם AI, אוטומציות ושילוב מערכות, ייעוץ ארגוני ושיפור תהליכים.\n\nהיקף כל פרויקט מוגדר בהצעת המחיר. שינויים בהיקף ("scope creep") יתומחרו בנפרד.`
  },
  {
    title: 'תמחור ותנאי תשלום',
    body: `• מחירים: לפי הצעת מחיר בלבד. לא מוצגים מחירים פומביים.\n• תשלום: לפי תנאים שסוכמו בהצעת המחיר (בדרך כלל: 50% מקדמה + 50% במסירה).\n• שיחת היכרות ראשונה: ללא עלות, עד 45 דקות.\n• ייעוץ שעתי: לפי הסכמה מוקדמת בכתב.`
  },
  {
    title: 'זכויות יוצרים וקניין רוחני',
    body: `• קוד, עיצוב, ותכנים שנוצרו עבור הלקוח — עוברים לבעלות הלקוח לאחר תשלום מלא.\n• כלים, תבניות ומסגרות עבודה שפותחו על-ידי FocusMode לפני הפרויקט — נשארים בבעלות FocusMode.\n• FocusMode שומרת זכות להציג את הפרויקט כ-portfolio, אלא אם הלקוח ביקש אחרת בכתב.`
  },
  {
    title: 'ביטול והפסקת עבודה',
    body: `• ביטול לפני תחילת עבודה: מקדמה תוחזר במלואה תוך 14 ימי עסקים.\n• ביטול לאחר תחילת עבודה: תחויב על שעות/תוצרים שהושלמו עד מועד הביטול.\n• FocusMode רשאית להפסיק שיתוף פעולה אם הלקוח מפר את תנאי ההתקשרות.`
  },
  {
    title: 'אחריות ומגבלות',
    body: `• FocusMode מתחייבת לעבודה מקצועית ובתום לב.\n• לא ניתנת ערובה לתוצאות עסקיות (עלייה במכירות, דירוג בגוגל, וכו').\n• אחריות מקסימלית מוגבלת לגובה התשלום ששולם בפרויקט הספציפי.\n• FocusMode אינה אחראית לנזקים תוצאתיים, עקיפים, או אובדן רווח.`
  },
  {
    title: 'סודיות',
    body: `כל מידע עסקי שנמסר ל-FocusMode במהלך הפרויקט ייחשב כסודי ולא יועבר לצדדים שלישיים, למעט לצורך ביצוע הפרויקט. הדבר חל לשני הכיוונים.`
  },
  {
    title: 'דין וסמכות שיפוט',
    body: `תנאים אלה כפופים לדין הישראלי. סמכות שיפוט ייחודית תהיה לבתי המשפט במחוז מרכז, ישראל.`
  },
  {
    title: 'שינויים בתנאים',
    body: `FocusMode רשאית לעדכן תנאים אלה. שינויים מהותיים יפורסמו באתר עם תאריך עדכון. המשך שימוש באתר לאחר עדכון מהווה הסכמה.`
  },
  {
    title: 'יצירת קשר',
    body: `לשאלות בנושא התנאים:\nEmail: yoav@focusmode.info\nWhatsApp: 052-410-6717`
  },
];

export default function Terms() {
  return (
    <main style={{ direction: 'rtl', fontFamily: 'Heebo, sans-serif' }}>
      <SEO
        title="תנאי שימוש · FocusMode"
        description="תנאי השימוש של FocusMode — היקף שירותים, תמחור, קניין רוחני, וסמכות שיפוט."
        path="/terms"
      />
      <section className="sec wrap" style={{ maxWidth: 760 }}>
        <div className="sec-eyebrow">מסמך משפטי · Terms of Service</div>
        <h1 className="h2">תנאי שימוש ומתן שירות</h1>
        <p className="lede" style={{ marginBottom: 8 }}>
          עודכן לאחרונה: 12 במאי 2026
        </p>
        <p style={{ fontSize: 16, lineHeight: 1.7, color: 'var(--ink-2)', marginBottom: 40 }}>
          שימוש באתר focusmode.info ופנייה ל-FocusMode לקבלת שירות מהווים הסכמה לתנאים הבאים.
          אם אינך מסכים לתנאים, אנא הימנע משימוש באתר.
        </p>

        {SECTIONS.map((s, i) => (
          <div key={i} style={{ marginBottom: 36, paddingBottom: 36, borderBottom: '1px solid var(--paper-2)' }}>
            <h2 style={{ fontFamily: 'Heebo, sans-serif', fontWeight: 900, fontSize: 'clamp(18px,2vw,22px)', marginBottom: 12 }}>
              {i + 1}. {s.title}
            </h2>
            <p style={{ fontSize: 16, lineHeight: 1.8, color: 'var(--ink-2)', whiteSpace: 'pre-line', margin: 0 }}>
              {s.body}
            </p>
          </div>
        ))}

        <div style={{ marginTop: 32, padding: '24px 28px', background: 'var(--yellow)', border: '2px solid var(--ink)', borderRadius: 16 }}>
          <p style={{ fontSize: 15, fontWeight: 700, margin: 0 }}>
            שאלות? תמיד עדיף לדבר ישירות.{' '}
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--ink)', borderBottom: '2px solid var(--ink)' }}>
              WhatsApp ←
            </a>
          </p>
        </div>
      </section>
    </main>
  );
}
